import { Service } from '@toeverything/infra';

import { slugify } from '../components/custom-app/utils/derive-row-slug';
import type { Row } from '../types/view-datasource.types';

export type SlugValidationResult =
  | { valid: true }
  | { valid: false; conflictRowId: string };

export class ContentDbSlugValidator extends Service {
  validate(
    rows: readonly Row[],
    seoSlugCol: string,
    currentRowId: string,
    newSlugValue: string
  ): SlugValidationResult {
    const trimmed = newSlugValue.trim();
    if (trimmed === '') return { valid: true };

    const slugified = slugify(trimmed);
    if (slugified === '') return { valid: true };

    for (const row of rows) {
      if (row.id === currentRowId) continue;
      const otherCell = row.cells[seoSlugCol];
      if (otherCell == null) continue;
      const otherSlug = slugify(String(otherCell));
      if (otherSlug === slugified) {
        return { valid: false, conflictRowId: row.id };
      }
    }
    return { valid: true };
  }
}
